'use client';
import React, { FC } from 'react';
import styled from 'styled-components';

import Link from '@/components/Link/Link';
import { Text } from '@/components/Text';
import ClientOnly from '@/helpers/ClientOnly';
import { formatDate } from '@/helpers/formatDate';
import { backgroundImageMixin } from '@/styles/BackgroundimageMixin';
import { devices } from '@/styles/breakpoints';
import { RegularText } from '@/styles/typography';
import { IBlog } from '@/types/blog';

interface IProps {
  item: IBlog;
  type: 'blog' | 'tutorial';
}

export const SmallCard: FC<IProps> = ({ item, type }) => {
  const [image] = JSON.parse(item.image);

  function addArticleJsonLd() {
    return {
      __html: `{
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": ${JSON.stringify(item?.title)},
        "description": ${JSON.stringify(item?.meta_description)},
        "image": ["${image?.preview_source}"],
        "publisher": {
          "@type": "Organization",
          "name": "Collaborator",
          "logo": {
            "@type": "ImageObject",
            "url": "${image?.preview_source}",
            "width": 150,
            "height":150
          }
        },
        "datePublished": "${new Date(item.created_at).toISOString()}",
        "dateModified": "${new Date(item.created_at).toISOString()}",
        "author": [{
          "@type": "Person",
          "name": "Alex G",
          "url": "https://orcatec.com"
        }]
      }`,
    };
  }

  return (
    <>
      {' '}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={addArticleJsonLd()}
        key={`articles-jsonld-${type}-${item.slug}`}
      />
      <Wrapper href={`/${type}/${item.slug}`} prefetch={false}>
        <ImageContent>
          <Overlay $imageSrc={image.preview_source}></Overlay>
        </ImageContent>
        <Content>
          <Desciption>{item.title}</Desciption>
          <ClientOnly>
            {' '}
            <Desciption
              className="description"
              dangerouslySetInnerHTML={{ __html: item.short_description }}
            />
          </ClientOnly>

          <Time>
            <span>{`${Math.floor(Math.random() * 8) + 3} min read`} </span>
            <span>{formatDate(item.created_at)}</span>
          </Time>
        </Content>
      </Wrapper>
    </>
  );
};

const Wrapper = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const ImageContent = styled.div`
  /* width: 100%; */
`;
const Content = styled.div`
  width: 100%;
  height: 90px;
  @media only screen and ${devices.desktop} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    height: 100%;
    /* height: 200px; */
  }
`;

const Overlay = styled.div<{ $imageSrc: string }>`
  position: relative;
  width: 146px !important;
  height: 90px !important;
  border-radius: 10px;
  border: 1px solid #e6e8ec;
  ${(props) => (props.$imageSrc ? backgroundImageMixin(props.$imageSrc) : '')};
  @media only screen and ${devices.desktop} {
    width: 264px !important;
    height: 164px !important;
  }
`;

const Desciption = styled(RegularText)`
  color: #192d52;
  font-family: var(--font-roboto);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  @media only screen and ${devices.desktop} {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    line-clamp: 3;
  }

  &.description {
    display: none;
    @media only screen and ${devices.desktop} {
      color: #192d52;
      font-size: 14px !important;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      & span {
        font-family: var(--font-roboto) !important;
        font-style: normal !important;
        line-height: 20px !important;
        line-height: 20px !important;
        font-size: 14px !important;
      }
    }
  }
`;

const Time = styled(Text)`
  font-size: 14px;
  font-weight: 400px;
  color: #4d4d4d;
  line-height: 20px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;
